// Decodifica el JWT para leer el campo "exp"
export function decodeToken(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload;
  } catch {
    return null;
  }
}

// Verifica si el token sigue vigente
export function isTokenValid(token) {
  if (!token) return false;
  const payload = decodeToken(token);
  if (!payload || !payload.exp) return false;
  const now = Date.now() / 1000; // tiempo actual en segundos
  return payload.exp > now;
}

// Cierra sesión eliminando token
export function logout() {
  localStorage.removeItem("token");
  window.location.href = "/"; // redirige al login
}
